import { useMemo, useState } from 'react';
import { useReference } from '@/lib/hooks';
import { Select } from './ui';

/** Dropdown of parties filtered by kind (vendor, customer, partner, employee, landlord…). */
export function PartyPicker({ value, onChange, kind, allowEmpty = true, placeholder = 'Pick a party', disabled, autoFocus }: { value: string | null | undefined; onChange: (id: string, party: any | null) => void; kind?: string | string[]; allowEmpty?: boolean; placeholder?: string; disabled?: boolean; autoFocus?: boolean }) {
  const { parties } = useReference();
  const kinds = kind ? (Array.isArray(kind) ? kind : [kind]) : null;
  const list = useMemo(() => parties.filter((p) => p.active !== false && (!kinds || kinds.includes(p.kind) || (p.kinds ?? []).some((k: string) => kinds.includes(k)))).sort((a, b) => a.display_name.localeCompare(b.display_name)), [parties, kinds?.join()]);
  return (
    <Select value={value ?? ''} disabled={disabled} autoFocus={autoFocus} onChange={(e) => { const id = e.target.value; onChange(id, list.find((p) => p.id === id) ?? null); }}>
      {allowEmpty && <option value="">{placeholder}</option>}
      {list.map((p) => <option key={p.id} value={p.id}>{p.display_name}{p.code ? ` (${p.code})` : ''}</option>)}
    </Select>
  );
}

/** Text search over parties for larger lists. */
export function PartySearch({ onPick, kind }: { onPick: (party: any) => void; kind?: string }) {
  const { parties } = useReference();
  const [q, setQ] = useState('');
  const hits = q.length < 2 ? [] : parties.filter((p) => (!kind || p.kind === kind) && (p.display_name.toLowerCase().includes(q.toLowerCase()) || (p.code ?? '').toLowerCase().includes(q.toLowerCase()))).slice(0, 8);
  return (
    <div className="party-search">
      <input className="input" placeholder="Search parties…" value={q} onChange={(e) => setQ(e.target.value)} />
      {hits.length > 0 && <ul className="more-list">{hits.map((p) => <li key={p.id}><a href="#" onClick={(e) => { e.preventDefault(); onPick(p); setQ(''); }}>{p.display_name} <small>{p.kind}</small></a></li>)}</ul>}
    </div>
  );
}
